export class Maybe {
    constructor(value) {
        this.value = value;
    }
    static some(value) {
        if (value === null || value === undefined) {
            throw Error("Provided value must not be empty");
        }
        return new Maybe(value);
    }
    static none() {
        return new Maybe(null);
    }
    static fromValue(value) {
        return value !== null && value !== undefined
            ? Maybe.some(value)
            : Maybe.none();
    }
    static run(gen) {
        function step(value) {
            const result = gen.next(value);
            if (result.done) {
                return result.value;
            }
            return result.value.flatMap(step);
        }
        return step();
    }
    withValue(f) {
        if (this.hasValue) {
            f(this.value);
        }
        return this;
    }
    withoutValue(f) {
        if (!this.hasValue) {
            f();
        }
        return this;
    }
    map(f) {
        if (this.value === null) {
            return Maybe.none();
        }
        else {
            return Maybe.fromValue(f(this.value));
        }
    }
    flatMap(f) {
        if (this.value === null) {
            return Maybe.none();
        }
        else {
            return f(this.value);
        }
    }
    getOrElse(defaultValue) {
        return this.value === null ? defaultValue : this.value;
    }
    get() {
        if (this.value === null) {
            throw new Error("Maybe.get() called with no value");
        }
        return this.value;
    }
    get hasValue() {
        return this.value !== null;
    }
}
//# sourceMappingURL=maybe.js.map